import { z } from 'zod';
/**
 * Nomenclatura única de los «Código» que se configuran (roles, tipos de caso, acciones, áreas, especialidades,
 * workflows, políticas SLA, calendarios, formularios, plantillas, esquemas de decisión, resultados):
 * mayúsculas, números y guion bajo. Un código no cambia después de creado: otros registros lo referencian.
 */
export const CODE_PATTERN = /^[A-Z0-9_]+$/;
export const CODE_MESSAGE = 'Solo mayúsculas, números y guion bajo';
export const CODE_HINT = 'Mayúsculas, números y guion bajo. No se puede cambiar después.';
export const CODE_MAX = 60;
/**
 * Lleva cualquier texto a un código: sin tildes, en mayúsculas, cada tramo de otros caracteres pasa a «_»
 * y sin «_» al principio ni al final. «Secretaría de Salud» → «SECRETARIA_DE_SALUD».
 * `keepTrailing` deja el «_» final mientras se escribe (para que se pueda teclear «A_B»).
 */
export function toCode(s, max = CODE_MAX, opts = {}) {
    const out = s
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '_')
        .replace(opts.keepTrailing ? /^_+/ : /^_+|_+$/g, '')
        .slice(0, max);
    return opts.keepTrailing ? out : out.replace(/_+$/, '');
}
/** Zod de un código: obligatorio, hasta `max` caracteres, solo `[A-Z0-9_]`. */
export const codeSchema = (max = CODE_MAX, min = 1) => z
    .string()
    .min(min, min > 1 ? `Al menos ${min} caracteres` : 'Escribe el código')
    .max(max, `A lo sumo ${max} caracteres`)
    .regex(CODE_PATTERN, CODE_MESSAGE);
/**
 * Serie de radicación: va dentro del número de radicado («PQRS-2026-000000123») y en la búsqueda del radicado en el
 * asunto de los correos, así que solo lleva mayúsculas y números (sin guion bajo ni separadores).
 */
export const RADICATION_SERIES_PATTERN = /^[A-Z0-9]+$/;
export const RADICATION_SERIES_MAX = 10;
export const radicationSeriesSchema = () => z.string().min(1, 'Escribe la serie').max(RADICATION_SERIES_MAX, `A lo sumo ${RADICATION_SERIES_MAX} caracteres`).regex(RADICATION_SERIES_PATTERN, 'Solo mayúsculas y números');
/** Normaliza lo que se escribe en una serie de radicación: sin tildes, en mayúsculas, solo letras y números. */
export const toRadicationSeries = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z0-9]+/g, '').slice(0, RADICATION_SERIES_MAX);
//# sourceMappingURL=code.js.map